import React, { Fragment } from "react"
import styled from "styled-components"
import Link from "gatsby-link"
import { below, above } from "../style/functions"
import CloseButton from "../svg/close.svg"
import DownArrow from "../svg/down-circle.svg"
// import RightArrowCircle from "../svg/right-arrow-circle"
import * as vars from "../style/vars"
import { RichText, Date } from "prismic-reactjs"
import bedIcon from '../../static/svg/bed.svg'
import bathIcon from '../../static/svg/bath.svg'
import carIcon from '../../static/svg/car.svg'
import studyIcon from '../../static/svg/study.svg'

class Accordion extends React.Component {
   constructor() {
      super()
      this.setContainerRef = element => {
         this.container = element
      }
      // this.handleClick = this.handleClick.bind(this)
   }

   handleClick = event => {
      this.container.classList.toggle("active")

      // let children = this.container.parentNode.childNodes
      // children.forEach(function(item) {
      //    if (item.classList.contains("active")) {
      //       item.classList.remove("active")
      //    }
      // })
      // if (event.target.tagName !== "circle") {
      //    this.container.classList.toggle("active")
      // }
   }
   
   render() {
      const { image, dir, cta, name, title, logo, html, bed, bath, car, study } = this.props
      return (
         <AccordionItem innerRef={this.setContainerRef} className="accor">
            <AccorTitle className="accorTitle" onClick={this.handleClick}>
							<div className="">
							 {logo ? (
								<LogoImg className="logo" src={logo} alt={name} />
							 ) : (
                         <h3>
                              {bed && 
                                 <Fragment>
                                    <img src={bedIcon} alt="bed icon" width="30px" />
                                    <Spec className="spec">
                                       {bed}
                                    </Spec>
                                 </Fragment>
                              }
                              {bath && 
                                 <Fragment>
                                    <img src={bathIcon} alt="bath icon" width="30px" />
                                    <Spec className="spec">
                                       {bath}
                                    </Spec>
                                 </Fragment>
                              }
                              {car && 
                                 <Fragment>
                                    <img src={carIcon} alt="car icon" width="42px" />
                                    <Spec className="spec">
                                       {car}
                                    </Spec>
                                 </Fragment>
                              }
                              {study && 
                                 <Fragment>
                                    <img src={studyIcon} alt="study icon" width="30px" />
                                    <Spec className="spec">
                                       {study}
                                    </Spec>
                                 </Fragment>
                              }

                         </h3>
							 )}
							 </div>
                     
               <img src={DownArrow} alt="down arrow" className="down-arrow" />
               <img src={CloseButton} alt="close button" className="close-button" />
            </AccorTitle>
            <AccorBody className="accorBody grid two-columns">
               <div className="col col-xs-12 col-06 padd-r">
                  {/* {name && !logo && <h3>{name}</h3>} */}
                  {dir !== "right" && (
                     <div className="col col-12 img-news-item">
                        <img src={image} alt={name} />
                     </div>
                  )}
                  {dir === "right" &&
                     html && (
                        <div>
                           {html}
                        </div>
                     )}
                  {dir === "right" &&
                     cta.link && (
                        <a href={cta.link} className="btn btn-arrow" target="_blank">
                           {cta.text}
                        </a>
                     )}
               </div>
               <div className="col col-xs-12 col-06 padd-r">
                  {dir === "right" && (
                     <div className="col col-12 img-news-item">
                        <img src={image} alt={name} />
                     </div>
                  )}
                  {dir !== "right" && html && <div>{html}</div>}
                  {dir !== "right" &&
                     cta.linik && (
                        <a href={cta.link} className="btn btn-arrow" target="_blank">
                           {cta.text}
                        </a>
                     )}
               </div>
            </AccorBody>
         </AccordionItem>
      )
   }
}

const AccordionContainer = styled.section`

   margin: 6rem auto;
	.accor:last-of-type{
		border-bottom: 1px solid ${vars.colors.body};

	}
   h3,
   h4,
   h5 {
      padding: 0;
   }

   h5 {
      margin: 1.5rem 0 1rem;
			font-size: 1.3rem;
   }
`

const AccordionItem = styled.div`
   position: relative;
   transition: background-color 0.3s ease-in-out;
   margin: 0 auto;

   .img-news-item {
      img {
         max-height: 490px;
      }
   }

   &.active {
      background: #dedede;
   }
`

const AccorTitle = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   padding: 2rem 3.5rem;
   border-top: 1px solid ${vars.colors.body};
   cursor: pointer;
	.logo{
		margin-bottom:0;
    filter: grayscale(100%);
	}
   .down-arrow,
   .close-button {
      width: 4rem;
   }

   .close-button {
      display: none;
   }

   .active & {
      .down-arrow {
         display: none;
      }
      .close-button {
         display: block;
      }
   }

   ${below.tablet`
      padding: 1rem;
      `}
`

const AccorBody = styled.div`
   transition: max-height 0.6s ease-in-out;
   overflow: hidden;
   max-height: 0;

   .active & {
      height: auto;
      max-height: 1500px;
   }

   .col {
      margin-bottom: 2rem;
			&:first-of-type{
				padding-left: 0 !important;
				border-left: none !important;
			}
   }
`
const LogoImg = styled.img`
   height: 30px;
   object-fit: contain;
   margin-bottom: 3rem;
`

const Spec = styled.span`
   margin-right: 3rem;
   margin-left: 1rem;
   ${below.mobile`
      vertical-align: super;
   `}
`

export { Accordion, AccordionContainer }



// WEBPACK FOOTER //
// ./src/components/accordion.js